import useAPI from '@/hooks/useAPI';
import InsuranceVerificationRepository from '@/repositories/InsuranceVerificationRepository';

const useInsuranceVerificationStatuses = (enabled = true) => {
  const insuranceVerificationRepository = InsuranceVerificationRepository();

  return useAPI({
    queryKey: ['getInsuranceVerificationStatuses'],
    queryFn: async () => {
      return await insuranceVerificationRepository.getVerificationStatuses();
    },
    enabled
  });
};

export default useInsuranceVerificationStatuses;
